/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreMorseListAliases {
  ADD_SCORE_MORSE_CUSTOM_DYNAMIC_BUTTON = 'add-score-morse-custom-dynamic-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_SCORE_MORSE = 'deck-score-morse',
  FETCH_SCORE_MORSE_LIST = 'fetch-score-morse-list',
  FILTERED_LIST_SCORE_MORSE = 'filtered-list-score-morse',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_SCORE_MORSE_LIST = 'layout-score-morse-list',
  LEGENDES_SCORE_MORSE = 'legendes-score-morse',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  SCORES_AND_INDEXES_CARD_0 = 'scores-and-indexes-card-0',
}
export { ScoreMorseListAliases };
